module.exports = __webpack_public_path__ + "img/syukyaku-EC-websit-001sp.9275d5bb.jpg";